/*!
 * Copyright Optimus Ride 2020
 */
import {
  PastReservation as GrpcPastReservation,
  Reservation as GrpcReservation,
} from '../../grpc/reservation_pb';
import { Moment } from 'moment-timezone';
import { toLocalDate } from '@optimusride/client-library/utils';

export interface Reservation {
  reservationId: number;
  scheduleId: number;
  operatingAreaId: number;
  reservationTimestamp: Moment;
  pickupLocationId: number;
  dropoffLocationId: number;
  numberOfSeats: number;
  notes: string;
  userId: number;
}

export interface ReservationWithStringTimestamp extends Omit<Reservation, 'reservationTimestamp'> {
  reservationTimestamp: string;
}

export interface PastReservation extends Reservation {
  isCancelled: boolean;
}

export function toReservation(reservation: GrpcReservation, operatingAreaTimezone: string): Reservation {
  return {
    reservationId: reservation.getReservationId(),
    scheduleId: reservation.getScheduleId(),
    operatingAreaId: reservation.getOperatingAreaId(),
    reservationTimestamp: toLocalDate(reservation.getReservationTimestamp(), operatingAreaTimezone),
    pickupLocationId: reservation.getPickupLocationId(),
    dropoffLocationId: reservation.getDropoffLocationId(),
    numberOfSeats: reservation.getNumberOfSeats(),
    notes: reservation.getNotes(),
    userId: reservation.getUserId(),
  }
}

export function toPastReservation(reservation: GrpcPastReservation, operatingAreaTimezone: string): PastReservation {
  return {
    ...toReservation(reservation.getReservation() || new GrpcReservation(), operatingAreaTimezone),
    isCancelled: reservation.getIsCancelled(),
  }
}
